import Box from '@mui/material/Box';
import React from 'react';
import HalfSizeBanner from '../components/Banners/HalfSizeBanner';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import Cards from '../components/Cards/Cards';
import Accordions from '../components/Accordions/Accordions';
import TextBtnSection from '../components/Section/TextBtnSection';
import SmallCards from '../components/Cards/SmallCards';
import BigCard from '../components/Cards/BigCard';
import ContentCard from '../components/Cards/ContentCard';
import { useTranslation } from '../hook/Translation';

export default function NeedleFreeRFFaceTightening() {
const { t } = useTranslation();
    const data = [
        {
            header: 'Face',
            description: 'Lift and sculpt the face without needles using cutting-edge electromagnetic and RF technologies',
            imageUrl: `${process.env.REACT_APP_SITE_URL}/images/2025/12/Mask Group 17.png`,
            // buttonText: 'LEARN MORE',
            // buttonUrl: '/'
        },
        {
            header: 'Neck',
            description: 'Lift and sculpt the face without needles using cutting-edge electromagnetic and RF technologies',
            imageUrl: `${process.env.REACT_APP_SITE_URL}/images/2025/12/Mask Group 18.png`,
            // buttonText: 'LEARN MORE',
            // buttonUrl: '/'
        }
    ]

    const accodirons = [
        {
            title: 'What it is?',
            content: 'A needle-free radiofrequency facial that tightens mildly lax skin and improves facial and neck contours without downtime.'
        },
        {
            title: 'How',
            content: 'An AI-guided RF handpiece delivers controlled thermal energy deep into the dermis. This heat contracts existing collagen and stimulates new collagen and elastin production, creating gradual lift and firmness from within.'
        },
        {
            title: 'Benefits',
            content: 'Firmer skin, softer fine lines, improved jawline and under-chin definition, and a smoother overall texture.'
        },
        {
            title: 'Areas',
            content: 'Face and neck are primary (cheeks, jawline, under-chin, around the eyes). It can also be used on the décolleté, upper arms, abdomen, thighs, and above the knees for mild laxity.'
        },
        {
            title: 'Pairs with other treatments',
            content: 'Works well alongside RF Microneedling and collagen-stimulating facials to enhance tightening and skin quality.'
        },
        {
            title: 'Downtime details',
            content: 'None. You may feel warmth and see mild redness for a short time after treatment.'
        },
        {
            title: 'When to expect results',
            content: 'Skin often feels tighter right away. Visible contour refinement and lifting typically build over a series of 3 to 6 sessions.'
        },
        {
            title: 'Results',
            content: 'Progressive improvement in firmness, support, and definition, with a more lifted look through collagen remodeling rather than volume or filler.'
        },
    ];

    const TextBtnSectionData = {
        type: t('skinTherapies'),
        title: "Emface Facial Muscle Lift & Tone (RF + HIFES)",
        description: "Non-surgical facelift effects. Emface is a breakthrough needle-free procedure that simultaneously tightens facial skin and tones the underlying muscles for a lifted, youthful look."
    };

    const data2 = [
        {
            imageUrl: '/images/fractional/hourglass-end.svg',
            title: t('time'),
            description: '30 to 45 min'
        },
        {
            imageUrl: '/images/fractional/headache.svg',
            title: t('discomfort'),
            description: 'Minimal to mild'
        },
        {
            imageUrl: '/images/fractional/duration.svg',
            title: t('downtime'),
            description: 'None'
        },
        {
            imageUrl: '/images/fractional/facial-treatment.svg',
            title: t('sessions'),
            description: '4 to 6'
        }
    ];

    return (
        <Box>

            <Box>
                <HalfSizeBanner>
                    <Box height={'100%'} bgcolor={'#1E353D'}>
                        <Box component={'img'} src={`${process.env.REACT_APP_SITE_URL}/images/2025/12/Emface_Men_Main_Long.png`} loading='lazy' height={1} width={1} className='fitCover' />
                    </Box>
                </HalfSizeBanner>
            </Box>

            <Box className="generalContainer" marginX={'auto'} marginTop={{md: '80px', xs: '50px'}}>
                <TextBtnSection data={TextBtnSectionData} titleSize={{ md: 8, xs: 12 }} descriptionSize={{ md: 9, xs: 12 }} />
            </Box>

            <Box marginTop={{md: '107px', xs: '50px'}}>
                <Box component={'img'} src='/images/fractional/Path 134.svg' width={1} sx={{ objectFit: 'cover' }} />
            </Box>

            <Box>
                <Box marginTop={{md: '104px', xs: '50px'}} className='generalContainer' marginX={'auto'}>
                    <SmallCards data={data2} />
                </Box>
            </Box>

            <Box sx={{ width: { md: '65%', xs: '90%' }, marginX: 'auto', marginTop: {md: '90px', xs: '50px'} }}>
                <Box sx={{ height: { md: 440, xs: 'auto' } }}>
                    <BigCard
                        data={{
                            book: '/',
                            type: 'Technology',
                            // learn: '/',
                            title: 'RF + HIFESTM',
                            size: { md: 8, xs: 12 },
                            imageSize: {md: 4, xs: 12},
                            btnContainer: { md: 10, xs: 12 },
                            imageUrl: `${process.env.REACT_APP_SITE_URL}/images/2026/01/ALMA.png`,
                            // flexDirection: {md: 'row-reverse', xs: 'row'},
                            description: 'RF gently heats the dermis to stimulate collagen and elastin production, improving skin firmness and elasticity. At the same time, HIFESTM delivers high-intensity electromagnetic stimulation to facial elevator muscles, increasing tone and lift. In just a 20-minute session, RF firms the skin while HIFESTM enhances muscle support in the forehead, cheeks, and jawline.'
                        }}
                        extraStyle={{
                            background: 'linear-gradient(90deg,rgba(30, 53, 61, 1) 0%, rgba(30, 53, 61, 1) 35%, rgba(30, 53, 61, 1) 50%, rgba(30, 53, 61, 1) 100%)'
                        }}
                        bgColor={'unset'}
                    />
                </Box>
            </Box>

            <Grid container gap={{md: '56px', xs: '40px'}} className="generalContainer" sx={{ marginX: 'auto', marginTop: {md: '100px', xs: '50px'} }}>
                <Grid size={12}>
                    <Typography textAlign={'center'} variant="body1" color="text.secondary" fontSize={'1.125rem'} fontWeight={'bold'}>Additional Information</Typography>
                </Grid>
                <Grid size={12}>
                    <Accordions data={accodirons} />
                </Grid>
            </Grid>

            <Grid bgcolor={'#F0F0EF'} marginTop={{md: '136px', xs: '50px'}} className="generalContainer" marginX={'auto'} container paddingY={{md: '80px', xs: '20px'}} paddingX={{md: '103px', xs: '20px'}} gap={'20px'}>
                <Grid size={12}>
                    <Typography textAlign={'center'} variant="body1" fontWeight={600} fontSize={{md: '1.125rem', xs: '1rem'}} color="text.secondary">Results</Typography>
                </Grid>
                <Grid size={12}>
                    <Typography textAlign={'center'} variant="body1" fontWeight={600} fontSize={{md: '1.875rem', xs: '1.5rem'}} color="text.secondary">Clinical studies show, on average, a 37% reduction in wrinkles, 23% improvement in lift, and 30% increase in muscle tone after a standard course of four sessions. All achieved without injections or downtime. Results continue to improve over several weeks as collagen and muscle tone rebuild.</Typography>
                </Grid>
            </Grid>

            <Grid container gap={{md: '44px', xs: '20px'}} className="generalContainer" sx={{ marginX: 'auto', marginTop: {md: '113px', xs: '50px'} }}>
                <Grid size={12}>
                    <Grid container spacing={3} justifyContent={'center'}>
                        <Grid size={12}>
                            <Typography textAlign={'center'} variant="body1" color="text.secondary" fontSize={'1.125rem'} fontWeight={'bold'}>Treatment Areas</Typography>
                            <Typography textAlign={'center'} variant="body1" color="text.secondary" marginTop={{md: '22px'}} fontWeight={'600'} marginX={'auto'} width={{ md: '994px', xs: '100%'}} fontSize={'1rem'}>The entire face can be treated using adhesive pads placed on the forehead and cheeks. Key benefits include eyebrow lift, sharper jawline, reduced nasolabial fold depth, and more open, refreshed eyes.</Typography>
                        </Grid>
                    </Grid>
                </Grid>
                <Grid size={12}>
                    <Cards data={data} imageHeight={'340px'} headerAlign={'center'} descriptionAlign={'center'} buttonAlign={'auto'} sizes={{ xs: 12, sm: 6, md: 6, lg: 6 }} />
                </Grid>
            </Grid>

            <Box bgcolor={'#DBDAD9'} marginTop={{md: '131px', xs: '50px'}}>
                <Grid container gap={{md: '89px', xs: '50px'}} className="generalContainer" marginX={'auto'} paddingTop={{md: '120px', xs: '50px'}} paddingBottom={{ md: '188px', xs: '50px' }}>
                    <Grid size={12}>
                        <ContentCard
                            data={{
                                imageUrl: '/images/Mask_Group_7.png',
                                type: 'Pairing',
                                title: 'EXION RF Skin Tightening',
                                description: 'Emface can be a standalone alternative to injectables, but it also plays well with others. For instance, combining Emface with our RF Skin Tightening Facial or Ultrasound Tightening can enhance skin firming. It’s also great to do a series of Emface, then maintain with occasional RF microneedling or a Lift & Sculpt Facial for ongoing collagen support.',
                                direction: { md: 'row-reverse', xs: 'row' },
                                learn: "/skin/fractional-co2-resurfacing",
                                book: '/'
                            }}
                            heigth={{ md: '440px', xs: 'auto' }}
                        />
                    </Grid>
                    <Grid size={12}>
                        <ContentCard
                            data={{
                                imageUrl: '/images/Mask_Group_7.png',
                                type: 'Pairing',
                                title: 'Lift & Sculpt Facial',
                                description: 'The Lift & Sculpt Facial can be positioned as your ongoing “touch-up” facial after an Emface series. Emface creates lift by increasing muscle tone and skin firmness in the midface, brow, and jawline. The Lift & Sculpt Facial maintains that effect by promoting circulation, drainage, and visible contouring through hands-on sculpting and targeted skin support. This keeps definition fresh between more technical treatments.',
                                learn: "/skin/fractional-co2-resurfacing",
                                book: '/'
                            }}
                            heigth={{ md: '440px', xs: 'auto' }}
                        />
                    </Grid>
                </Grid>
            </Box>
        </Box>
    )
}